<template>
  <v-row>
    <v-col class="pr-0">
      <v-text-field
        v-model="date"
        :dense="dense"
        :label="label"
        hint="Year-Month-Day"
        :rules="dateRules"
        :disabled="disabled || disabledDate"
      >
        <template #prepend-inner>
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
            class="d-inline"
            :disabled="disabled"
          >
            <template #activator="{ on }">
              <v-icon v-on="on">event</v-icon>
            </template>
            <v-date-picker
              v-model="date"
              :min="minDate"
              :max="maxDate"
              @change="dateMenu = false"
            ></v-date-picker>
          </v-menu>
        </template>
      </v-text-field>
    </v-col>
    <v-col class="pl-0">
      <v-text-field
        :dense="dense"
        v-model="time"
        prefix="at"
        hint="24-hour time"
        :rules="timeRules"
        :disabled="disabled"
      >
        <template #append>
          <v-menu
            v-model="timeMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            offset-x
            min-width="290px"
            class="d-inline"
            :disabled="disabled"
          >
            <template #activator="{ on }">
              <v-icon v-on="on">alarm</v-icon>
            </template>
            <v-time-picker
              ref="timePicker"
              v-model="time"
              @change="closeTimePicker"
              format="24hr"
            ></v-time-picker>
          </v-menu>
        </template>
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { DateTime } from "luxon";

export default {
  name: "DateTimeField",
  props: {
    dense: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Date],
      required: false,
      default: "",
    },
    returnObject: {
      type: Boolean,
      required: false,
      default: false,
    },
    dateRules: {
      type: Array,
      required: false,
      default: () => [],
    },
    timeRules: {
      type: Array,
      required: false,
      default: () => [],
    },
    minDate: {
      type: String,
      required: false,
    },
    maxDate: {
      type: String,
      required: false,
    },
    disabledDate: {
      type: Boolean,
      required: false,
      default: false,
    },
    timezone: {
      type: String,
      required: false,
      default: "local",
    },
  },
  data() {
    return {
      dateMenu: null,
      timeMenu: null,
      dateVal: new Date().toISOString().split("T")[0],
      timeVal: "00:00",
    };
  },
  computed: {
    datetime: {
      get() {
        if (this.dateVal == null) return null;
        return `${this.dateVal} at ${this.timeVal}`;
      },
    },
    time: {
      get() {
        return this.timeVal;
      },
      set(val) {
        this.timeVal = val;
        this.saveDateTime();
      },
    },
    date: {
      get() {
        return DateTime.fromISO(this.dateVal, { zone: this.timezone }).toISODate();
      },
      set(val) {
        this.dateVal = val;
        this.saveDateTime();
      },
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (oldVal) {
        this.updateDateTime();
      }
    },
  },
  beforeCreate() {},
  created() {
    if (this.value === null) {
      this.saveDateTime();
    } else {
      this.updateDateTime();
    }
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},

  methods: {
    emitChange(value = null) {
      const result = value || this.value;

      this.$emit("input", result);
      this.$emit("change");
    },
    saveDateTime() {
      const datetime = DateTime.fromISO(`${this.date}T${this.time}`, { zone: this.timezone });

      // if valid date
      if (!datetime.invalid) {
        if (this.returnObject) {
          this.$emit("input", datetime);
          this.$emit("change");
        } else {
          this.$emit("input", datetime.toISO());
          this.$emit("change");
        }
      }
    },
    updateDateTime() {
      const datetime = DateTime.fromISO(this.value, { zone: this.timezone });
      this.dateVal = datetime.toISODate();
      this.timeVal = datetime.toISOTime({
        suppressSeconds: true,
        suppressMilliseconds: true,
        includeOffset: false,
      });
    },
    closeTimePicker() {
      this.timeMenu = false;
      this.$refs.timePicker.selectingHour = true;
    },
  },
};
</script>
